// Interpolation values for strings that mention a profession. Every case the
// backend sends ({{nominative}}, {{genitive}}, {{dative}}, …) is available so
// each language's string can pick the one its grammar needs; {{name}} keeps
// the case the caller chose (the form the Ukrainian strings were written for).
const CASES = ['nominative', 'genitive', 'dative', 'accusative', 'instrumental', 'locative'];

const professionCases = (profession, nameCase = 'nominative') => {
  const declensions = profession?.declensions || {};
  const base = declensions.nominative || profession?.name || '';
  const vars = {};
  CASES.forEach((c) => {
    vars[c] = declensions[c] || base;
  });
  vars.name = declensions[nameCase] || base;
  return vars;
};

export default professionCases;
